import React from 'react'

const SendIcon = ({...props} ):JSX.Element => {
  return (
    
<svg width="25" height="25" viewBox="0 0 25 25" fill={props.Fill ? props.Fill : 'yellow'} xmlns="http://www.w3.org/2000/svg">
<path d="M15.7003 23.777C15.5076 24.226 15.1746 24.5026 14.7013 24.6068C14.2286 24.7116 13.8161 24.5878 13.4636 24.2354L9.88317 20.6549C9.65889 20.4306 9.52281 20.1662 9.47493 19.8616C9.42704 19.5571 9.49136 19.2685 9.66789 18.9958L14.9159 10.2875L6.20757 15.5355C5.93493 15.7121 5.64633 15.7764 5.34177 15.7285C5.03722 15.6806 4.7728 15.5445 4.54852 15.3203L0.968057 11.7398C0.615618 11.3873 0.4915 10.9745 0.595704 10.5012C0.700548 10.0285 0.977469 9.69584 1.42647 9.50316L22.4969 0.928257C23.0742 0.703429 23.5711 0.799276 23.9876 1.2158C24.4041 1.63231 24.5 2.12921 24.2752 2.70648L15.7003 23.777Z" fill={props.Fill ? props.Fill : 'yellow'}/>
</svg>


  )
}

export default SendIcon
